import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrigineDemande } from 'src/app/shared/models/origineDemande';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { OrigineDemandeModalAjoutComponent } from '../modal/origineDemande-modal-ajout/origineDemande-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { OrigineDemandeModalDetailComponent } from '../modal/origineDemande-modal-detail/origineDemande-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-origineDemande',
	templateUrl: './list-origineDemande.component.html',
	styleUrls: ['./list-origineDemande.component.scss']
})
export class ListOrigineDemandeComponent implements OnInit {
	origineDemande: OrigineDemande[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	origineDemandeCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editOrigineDemandeModalRef: BsModalRef;
	addOrigineDemandeModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getOrigineDemande();
		this.isAddable = true;
	}

	getOrigineDemande(): void {
		this.isListingLoading = true;
		this.facade.origineDemandeService.getAllOrigineDemande().subscribe({
			next: (val) => {
				this.origineDemande = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.origineDemande.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.origineDemande = [];
			}
		});
	}

	selectOrigineDemande(origineDemande: OrigineDemande): void {
		const link = ['/origineDemande', origineDemande.id];
		this.router.navigate(link);
	}

	importOrigineDemande(event: any): void {
		this.origineDemandeCsvFile = event.target.files[0];

		this.facade.origineDemandeService
			.importOrigineDemande(this.origineDemandeCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} origineDemande ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getOrigineDemande();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addOrigineDemandeModalRef = this.modalService.show(
			OrigineDemandeModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addOrigineDemandeModalRef.onHide.subscribe((reason: string | any) => {
			this.getOrigineDemande();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(origineDemande: OrigineDemande) {
		const initialState = {
			origineDemande: origineDemande
		};
		this.editOrigineDemandeModalRef = this.modalService.show(
			OrigineDemandeModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editOrigineDemandeModalRef.onHide.subscribe((reason: string | any) => {
			this.getOrigineDemande();
		});
	}
}
